<template>
  <div>
    <div class="flex justify-between mb-6">
      <div class="flex items-center justify-start gap-8">
        <span class="cursor-pointer board__inactive" :class="{
          board__active: boardType === 'active',
        }" id="active" @click="boardType = 'active'">
          <h4 class="text-lg w-fit whitespace-no-wrap">Active Boards</h4>
        </span>

        <span class="hidden cursor-pointer board__inactive" :class="{
          board__active: boardType === 'paused',
        }" id="paused" @click="boardType = 'paused'">
          <h4 class="text-lg w-fit whitespace-no-wrap">Paused</h4>
        </span>

        <span class="cursor-pointer board__inactive" :class="{
          board__active: boardType === 'archived',
        }" id="Archived" @click="boardType = 'archived'">
          <h4 class="text-lg w-fit whitespace-no-wrap">Archived</h4>
        </span>
      </div>
      <vs-button class="w-max rounded-lg text-white text-xl mt-4 pl-4" @click="createBoard"
        :color="orgData.primaryThemeColor">
        <feather-icon icon="PlusIcon" svgClasses="stroke-current text-white" class="w-6 h-6 mr-1" />
        Create New Board</vs-button>
    </div>
    <div v-if="isBoardLoading">
      <vs-row class="px-4 py-4 rounded-lg flex flex-col gap-6">
        <!-- class="px-4 py-4 rounded-lg grid flex-col lg:grid-cols-2 grid-cols-1 gap-6" -->
        <vs-row v-for="i in 6" :key="i" class="p-24 animate-pulse rounded-lg bg-slate-200" />
      </vs-row>
    </div>
    <div v-else class="py-4">
      <div class="flex flex-col gap-6" v-if="boards && boards.length > 0">
        <!-- class="grid flex-col lg:grid-cols-2 grid-cols-1 gap-6" -->
        <board-item-card v-for="(board, index) in boards" :key="index" :boardData="board" />
      </div>
      <div v-else class="w-full flex flex-col items-center justify-center gap-3">
        <img src="@/assets/images/temp-img/empty-archive-boards.svg" alt="Empty Boards" class="w-1/4">
        <p class="text-2xl text-black">No {{ boardType }} boards found!</p>
      </div>
    </div>
  </div>
</template>

<script>
import BoardItemCard from "./components/BoardItemCard.vue";

export default {
  components: {
    BoardItemCard,
  },
  data() {
    return {
      boards: [],
      isBoardLoading: true,
      boardType: "active",
    };
  },
  computed: {
    orgData() {
      return this.$store.state.organization.orgData;
    },
    userData() {
      return this.$store.state.users.data;
    },
  },
  watch: {
    boardType: {
      deep: true,
      immediate: true,
      handler(newVal) {
        this.isBoardLoading = true;
        if (newVal === "archived") {
          this.getOrgArchivedBoards();
        } else {
          this.getOrgActiveBoards();
        }
      },
    },
    orgData: {
      deep: true,
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.isBoardLoading = true;
          this.getOrgActiveBoards();
        }
      },
    },
  },
  mounted() {
    this.getOrgActiveBoards();
  },
  methods: {
    getOrgActiveBoards() {
      if (this.orgData && this.orgData._id) {
        this.$store
          .dispatch("boards/fetchAllBoards", this.orgData._id)
          .then((res) => {
            this.boards = res.data.filter((e) => e.status != "archived");
            this.boards = this.boards.filter((e) => e.status != "deactivated");
          })
          .catch((err) => {
            throw err;
          })
          .finally(() => {
            this.isBoardLoading = false;
          });
      }
    },
    getOrgArchivedBoards() {
      this.$store
        .dispatch("boards/fetchAllArchivedBoards", this.orgData._id)
        .then((res) => {
          this.boards = res.data;
        })
        .catch((err) => {
          throw err;
        })
        .finally(() => {
          this.isBoardLoading = false;
        });
    },
    generateBoardSlug(boardTitle) {
      let slug = "default";
      if (boardTitle) {
        let r = (Math.random() + 1).toString(36).substring(3);
        slug =
          boardTitle
            .toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "") +
          "-" +
          r;
      }
      return slug;
    },
    createBoard() {
      const payload = {
        boardId: "custom-kanban-board",
        userId: this.userData._id,
        organizationId: this.orgData._id,
        paymentStatus: "pending",
        status: "draft",
        boardView: "kanban",
        title: "Hiring Board",
        slug: this.generateBoardSlug("default-title"), // temporary
      };
      this.$store
        .dispatch("boards/createBoard", payload)
        .then((res) => {
          this.$router.push(
            `/organization/${this.orgData.slug}/create-board/${res.data._id}`
          );
        })
        .catch((err) => {
          throw err;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.board {
  &__inactive {
    h4 {
      color: #5e5b5b !important;
      font-weight: 400;
    }
  }

  &__active {
    h4 {
      color: #101828 !important;
      font-weight: 600;
    }
  }
}

.vs-button {
  &::v-deep &-text {
    display: flex;
    align-items: flex-start;
  }
}
</style>
